import React from 'react';

const AddProduct = () => {
    return (
        <div>
            <h1> Admin add product</h1>
        </div>
    );
};

export default AddProduct;